<template>
  <div class="container is-fluid">
    <div class="columns">
      <div class="column">
        <Breadcrumbs :links="links" />

        <div class="columns">
          <div class="column is-two-thirds-desktop">
            <ParticipantWidget />
          </div>
          <div class="column">
            <EventWidget />
          </div>
        </div>

        <div class="columns">
          <div class="column is-full-mobile is-two-thirds-desktop">
            <div class="columns is-multiline">
              <div class="column is-full is-half-desktop">
                <DivisionWidget />
              </div>
              <div class="column is-full is-half-desktop">
                <JudgeWidget />
              </div>
              <div class="column is-full">
                <SubmissionWidget />
              </div>
            </div>
          </div>

          <div class="column is-one-third-desktop">
            <div class="columns">
              <div class="column">
                <LogsWidget />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
const Breadcrumbs = () => import('@/components/admin/Breadcrumbs')
const EventWidget = () => import('@/components/admin/widgets/EventWidget')
const DivisionWidget = () => import('@/components/admin/widgets/DivisionWidget')
const ParticipantWidget = () => import('@/components/admin/widgets/ParticipantWidget')
const JudgeWidget = () => import('@/components/admin/widgets/JudgeWidget')
const LogsWidget = () => import('@/components/admin/widgets/LogsWidget')
const SubmissionWidget = () => import('@/components/admin/widgets/SubmissionWidget')

export default {
  name: 'AdminDashboard',
  metaInfo: {
    title: `Admin Dashboard - ${process.env.VUE_APP_PAGE_TITLE}`
  },
  data () {
    return {
      links: [
        {
          label: 'Dashboard',
          routeName: 'admin-dashboard',
          isActive: true,
          icon: 'dashboard'
        }
      ]
    }
  },
  components: {
    Breadcrumbs,
    EventWidget,
    DivisionWidget,
    ParticipantWidget,
    JudgeWidget,
    LogsWidget,
    SubmissionWidget
  }
}
</script>

<style lang="scss">
  .tile{
    &.notification{
      .title{
        margin-bottom: .5em;
      }
      a.subtitle{
        text-decoration: none;
        // &:hover{
        //   text-decoration: underline;
        // }
      }
    }
    &.is-child{
      .settings-icon > .material-design-icon__svg{
        transform: rotate(0deg);
        transition: transform .5s;
      }
      &:hover{
        .settings-icon > .material-design-icon__svg{
          transform: rotate(180deg);
          transition: transform .5s;
        }
      }
    }
  }
</style>
